module.exports = __webpack_public_path__ + "img/9788998157296.0c150b75.jpg";